import { Goal, OrgNode } from './';

export class RolledUpGoalsByOrgNode{
    public RolledUpGoalsByOrgNodeId:string;
    public OrgNodeId:string;
    public GoalId:string;
    public FiscalYearId:number;
    public Progress:number;
    public GoalValue:number;
    public NumClubsWithGoalSet:number;

    public OrgNode:OrgNode;
    public Goal:Goal;

    constructor(RolledUpGoalsByOrgNodeId:string = null, OrgNodeId:string = null, GoalId:string = null, FiscalYearId:number = 0, Progress:number = 0, GoalValue:number = 0, NumClubsWithGoalSet:number = 0, OrgNode:OrgNode = null, Goal:Goal = null){
        this.RolledUpGoalsByOrgNodeId = RolledUpGoalsByOrgNodeId;
        this.OrgNodeId = OrgNodeId;
        this.GoalId = GoalId;
        this.FiscalYearId = FiscalYearId;
        this.Progress = Progress;
        this.GoalValue = GoalValue;
        this.OrgNode = OrgNode;
        this.Goal = Goal;
        this.NumClubsWithGoalSet = NumClubsWithGoalSet;
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/entities/rolled-up-goals-by-org-node.ts